import {bus} from "../constants/bus";

export default function (handler) {
	return {
		computed: {
			eventBus() {
				return {
					$emit: (event, data) => {
						bus.$emit(event, data);
					},
					$on(event, data) {
						bus.$on(event, data);
					},
					$handle(event, data) {
						handler.handle(event, data, bus);
					},
				};
			},
		},
	};
};
